<template>
    <div class="home">
        <v-container fill-height>
            <v-row v-for="row in reportLayouts" :key="row.id">
                <v-col cols="12" :key="chart.chartId" v-for="chart in row.cols" :md="chart.colSpan" xs="12" sm="12">
                    <chart-view :chart-id="chart.chartId"
                                :key="chart.id"
                                :chart-type="chart.chartType"
                                :report-layout-id="chart.reportLayoutId"
                                @replaced="onReplaced"></chart-view>
                </v-col>
            </v-row>
        </v-container>

        <chart-selector :visible.sync="isChartSelectorVisible" v-on:on-close="onChartSelectorClose"></chart-selector>
    </div>
</template>

<script>
    import ChartSelector from "../components/charts/ChartSelector"
    import ChartView from "../components/charts/ChartView"
    import reportLayoutService from "../services/reportLayoutService"

    export default {
        name: 'Home',
        data: function () {
            return {
                reportLayouts: [],
                isChartSelectorVisible: false
            }
        },
        components: {
            ChartSelector,
            ChartView
        },
        methods: {
            async setup() {
                this.accessToken = this.$auth.getAccessToken();

                if (this.accessToken) {
                        await this.getReportLayout("Dashboard");
                }
            },
            async getReportLayout(name) {
                let results = await reportLayoutService.getReportLayoutsByName(name, false, this.accessToken);

                let reportRows = [];

                results.forEach(function (item) {

                    if (!reportRows[item.row - 1]) {
                        reportRows.push({
                            cols: [
                                {
                                    chartId: item.chartId,
                                    chartType: item.chartType,
                                    reportLayoutId: item.id,
                                    colSpan: item.colSpan
                                }
                            ]
                        });
                    }
                    else {
                        reportRows[item.row - 1].cols.push({
                            chartId: item.chartId,
                            chartType: item.chartType,
                            reportLayoutId: item.id,
                            colSpan: item.colSpan
                        });
                    }

                });

                this.reportLayouts = reportRows;
            },
            getCols(cols) {
                return Math.floor(12 / cols);
            },
            onChartSelectorClose() {
                this.isChartSelectorVisible = false;
            },
            onReplaced() {
                this.reportLayouts = [];
                this.getReportLayout("Dashboard");
            }
        },
        created() {
            this.setup();
        }
    }
</script>
